{
  "zh-CN": {
    "fleetDashboard": {
      "showAll": "查看全部",
      "empty": "暂无内容。",
      "failed": "暂时无法加载。",
      "unnamed": "未命名",
      "formats": {
        "weekday": "EEE",
        "day": "d"
      },
      "activity": {
        "title": "最新动态",
        "you": "你",
        "kinds": {
          "member_joined": "加入了舰队",
          "event_published": "活动已发布",
          "event_cancelled": "活动已取消",
          "contract_published": "合同已发布",
          "contract_claimed": "合同已认领",
          "contract_fulfilled": "合同已完成",
          "inventory_transfer_completed": "转移已完成",
          "inventory_item_deposited": "已存入",
          "inventory_item_withdrawn": "已取出"
        },
        "empty": {
          "title": "还没有动态",
          "hint": "已发布的活动和合同会显示在这里，最新的在最前。"
        }
      },
      "events": {
        "title": "即将到来的活动",
        "signUp": "报名",
        "empty": {
          "title": "未来两周没有安排",
          "hint": "查看活动页面了解之后的安排。",
          "hintCreate": "在日历上安排一次行动，成员即可立即报名。",
          "action": "安排活动"
        }
      },
      "actionQueue": {
        "title": "待你处理",
        "joinRequests": {
          "one": "%{count} 个入队申请",
          "other": "%{count} 个入队申请"
        },
        "pendingTransfers": {
          "one": "%{count} 个待处理的转入",
          "other": "%{count} 个待处理的转入"
        },
        "partFailed": "部分待处理事项暂时无法加载。",
        "empty": {
          "title": "全部处理完毕",
          "hint": "需要回应的入队申请和传入转移会显示在这里。"
        },
        "memberHealth": {
          "one": "%{count} 项成员检查需要处理",
          "other": "%{count} 项成员检查需要处理"
        }
      },
      "contracts": {
        "title": "合同",
        "mine": "你的工作",
        "open": "可接取",
        "partFailed": "部分合同暂时无法加载。",
        "empty": {
          "title": "没有开放的合同",
          "hint": "在合同面板查看以往的工作。",
          "hintCreate": "发布一项工作，成员即可接取。",
          "action": "发布合同"
        }
      },
      "inventory": {
        "title": "库存",
        "empty": "最近没有库存变动。",
        "emptyMine": "最近没有与你相关的变动。",
        "emptyHint": "存入、取出和转移会显示在这里。",
        "mine": "我的",
        "fleet": "舰队"
      },
      "newMembers": {
        "title": "新成员",
        "empty": {
          "title": "最近没有新成员",
          "hint": "成员加入后会显示在这里。"
        }
      },
      "about": {
        "title": "关于舰队",
        "empty": {
          "title": "还没有简介",
          "hint": "舰队还没有介绍自己。",
          "hintEdit": "告诉新成员舰队是做什么的。",
          "action": "撰写简介"
        }
      },
      "week": {
        "emptyDay": "%{day} 没有安排。"
      },
      "online": {
        "title": "当前在线（%{count}）",
        "titlePending": "当前在线",
        "friend": "好友",
        "more": {
          "one": "还有 %{count} 人",
          "other": "还有 %{count} 人"
        },
        "empty": {
          "title": "没有其他人在线",
          "hint": "成员登录后会立即显示在这里。"
        }
      },
      "announcements": {
        "post": "发布公告",
        "postAction": "发布",
        "edit": "编辑公告",
        "body": "公告",
        "until": "截至 %{date}",
        "confirmRemove": "要为所有人删除此公告吗？",
        "expiry": {
          "label": "显示时长",
          "keep": "保持当前截止时间",
          "never": "直到被删除",
          "day": "一天",
          "days3": "三天",
          "week": "一周",
          "weeks2": "两周"
        },
        "messages": {
          "saved": "公告已保存。",
          "saveFailed": "无法保存公告。",
          "removed": "公告已删除。",
          "removeFailed": "无法删除公告。"
        },
        "more": {
          "one": "再显示 %{count} 条公告",
          "other": "再显示 %{count} 条公告"
        }
      }
    }
  }
}
